module dg.objects {

    class PeriodController {

        public constructor(
            private periodService: dg.objects.PeriodService,
            private $scope: ng.IScope) { }

        $onInit() {
            this.periodOptions = this.periodService.getPeriodOptions();
            this.valueObj = this.periodService.convertToClient(this.value);

            this.$scope.$watch('$ctrl.valueObj', (val: any) => {
                this.updateValue();
            }, true);   
        }

        $onChanges(changes) {
            if (!changes.value.currentValue) {
                this.valueObj = {};
            }

            let newVal = this.periodService.convertToClient(this.value);
            this.valueObj = dgUtils.ObjectHelperService.mergeDeep(this.valueObj, newVal);
        }

        public ngModel: ng.INgModelController;
        public domainObjectCtrl: dg.objects.ObjectEditorController;
        public periodOptions: any;
        public readonly: boolean;
        public valueObj: IPeriod;
        public value: dg.domain.model.Period;

        public yearPicker = {};

        public clear() {
            this.valueObj = {};
            this.ngModel.$setViewValue(null);
        }

        public updateValue = () => {
            if (this.periodService.checkValidity(this.valueObj)) {
                let serverValue = this.periodService.convertToServer(this.valueObj);
                this.ngModel.$setViewValue(serverValue);
            }
        };
    }

    angular.module('dg.objects').component('period', {
        bindings: {
            value: '<ngModel',
            readonly: '<'
        },
        require: {
            ngModel: 'ngModel',
            domainObjectCtrl: '^objectEditor'
        },
        controller: PeriodController,
        templateUrl: '/digmo/src/objects/properties/date/period.html'
    });
}